import { app } from '../../../../../app';
import { Controller } from './app-api-credentials.controller';

app.component('appApiCredentials', {
    bindings: {
        application: '<',
    },
    controller: Controller,
    templateUrl: require('./app-api-credentials.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/app-integration-instructions/local/app-api-credentials/app-api-credentials.component.js